import configs from '../config'

// Get the name of the current environment from `<body data-env="...">`,
const envName = document.querySelector('meta[name="stage"]')?.getAttribute('content') || 'defaultConfig'
const config = configs[envName as unknown as keyof typeof configs]

if (!config) throw new Error()

export { config }
